import { IconProps } from "../../utils/global-types/global-types";

const FeatureRequestStarIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    fill="none"
    className={className ? className : "w-[25px] h-[25px]"}
    {...rest}
  >
    <g clipPath="url(#clip0_feat_star)">
      <path
        d="M24.824 9.547a1.32 1.32 0 0 0-1.138-.908l-7.184-.653-2.84-6.647a1.335 1.335 0 0 0-2.434 0L8.39 7.986l-7.186.652A1.335 1.335 0 0 0 .451 10.953l5.431 4.762-1.601 7.053a1.335 1.335 0 0 0 2.115 1.43l6.05-3.702 6.193 3.7a1.335 1.335 0 0 0 2.07-1.432l-1.602-7.052 5.431-4.763a1.335 1.335 0 0 0 .386-1.402Z"
        fill="#EAC11D"
      />
    </g>
    <defs>
      <clipPath id="clip0_feat_star">
        <rect width="24.889" height="24.889" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FeatureRequestStarIcon;
